var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.0614736 8.33064V6.3366H20.038L15.3782 1.67676L16.7924 0.262548L23.8634 7.33362L16.7924 14.4047L15.3782 12.9905L20.038 8.33064H0.0614736Z",
    fill: "#F8BA2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowArrow);
export default __webpack_public_path__ + "static/media/yellow_arrow.ef0cbf915eabd0456903b8490cecbab1.svg";
export { ForwardRef as ReactComponent };